export default __webpack_public_path__ + "static/media/MusicH3.c0b59bd8.png";